module.exports = __webpack_public_path__ + "img/6.56295087.jpg";